import React, { Component } from 'react';
import './Deals.css';
import { DealItem } from './DealItem';
import SimpleSlider from '../SimpleSlider/SimpleSlider';
import { Img } from '../UI/UI';
import { getImgUrl, limitText } from '../../Utility/Utility';

class Deals extends Component {
  constructor(props) {
    super(props);
    this.image_url = getImgUrl();

    this.dealsSliderSettings = {
      dots: true,
      infinite: true,
      cssEase: 'linear',
      autoplay: true,
      lazyLoad: 'ondemand',
      slidesToShow: this.props.items != undefined ? this.props.items : 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    this.deals =[

		{
  
		  title: 'Tel Aviv Air',
		  desc: 'Hamburg – Tel Aviv Non Stop, Handgepäck bis 8 kg,16.12.2021 – 31.03.2022',
		  price: '99 € ',
		  logo: 'Deals/tlv.jpg',
		  link:'https://tlv-air.com/en/home-en/',
		  cssclass: 'unic-deal-1',
		  book_now: 'BUCHEN SIE JETZT',
		},


		{
  
		  title: 'Fit Reisen',
		  desc: 'Hotel Ein Gedi ***ˢ Kuren und entspannen am Toten Meer, 7 Nächte im DZ inkl. HP & Eintritt ins Ein Gedi Health Spa',
		  price: '589 € ',
		  logo: 'Deals/Fit Reisen.jpg',
		  link:'https://www.fitreisen.de/hotel-ein-gedi-ein-gedi-totes-meer-h347/?utm_source=teaser_extern&utm_medium=fva&utm_campaign=israel1#dmin=7&p=347P2NN',
		  cssclass: 'unic-deal-1',
		  book_now: 'BUCHEN SIE JETZT',
		},
					  {
  
		  title: 'Fit Reisen',
		  desc: 'Lot Spa Hotel **** Wellness & Entspannung (auch als Klimakuraufenthalt), 7 Nächte im DZ inkl. HP & Eintritt zum Spa ',
		  price: ' 609 € ',
		  logo: 'Deals/Fit Reisen.jpg',
		  link:'https://www.fitreisen.de/lot-spa-hotel-ein-bokek-totes-meer-h343/?utm_source=teaser_extern&utm_medium=fva&utm_campaign=israel2#dmin=7&p=343P1NN',
		  cssclass: 'unic-deal-1',
		  book_now: 'BUCHEN SIE JETZT',
		},
  
  
		{
		  title: 'Israel Rail',
		  desc: '8-Tage-Tour Israel Highlights mit der Bahn',
		  price: '699 € ',
		  logo: 'Deals/Israel Rail.jpg',
		  link: 'https://israelrail.com/de/tours/israel-highlights-mit-der-bahn-8-tage/',
		  cssclass: 'unic-deal-1',
		  book_now: 'BUCHEN SIE JETZT',
		},
  
		{
		  title: 'DerTour',
		  desc: 'Hotel Savoy**** Stylisches Boutique-Hotel in Tel Aviv 5 Nächte/Frühstück, Transfers, Flug ab Deutschland',
		  price: '721 € ',
		  logo: 'Deals/DerTour.jpg',
		  link:'https://www.dertour.de/hotel/savoy-hotel-TLV01118VA?ttid=PF&bdid=i&toid=dy&hid=TLV01118&ptid=VA&ssnid=W21&na=2&nc=0&ap=BER&nn=5&mnth=2022-01-16&fidd=2022-01-16&fird=2022-01-21&fid=00&fir=00&fcd=BERTLV&fcr=TLVBER&fiswt=1&fddtd=202201160700&fddta=202201161215&frdtd=202201211310&frdta=202201211645&fad=U2&far=U2&rid=RB&bid=BB&bcid=RB+B&lndpu=%2Fangebote%2F%3Fpdaf%3DBER%26pdf%3D4030573%26psdf%3D2022-01-16%26psdsf%3D2022-01-16%26pedf%3D2022-01-21%26pedsf%3D2022-01-21%26searchMode%3Dflexible%26pnnfl%3D5%26pnnfh%3D8%26pna%3D2%26pnc%3D0%26ttid%3DPF&dft=apx',
		  cssclass: 'unic-deal-1',
		  book_now: 'BUCHEN SIE JETZT',
		},
  
		{
		  title: 'Israel Tours & Travel',
		  desc:'EIN EINMALIGES ERLEBNISREISE IN DER ARAVA WÜSTE 7 NÄCHTE Ü/F',
		  price: '759 € ',
		  logo: 'Deals/Israel Tours & Travel.jpg',
		  link:'https://www.israel-tours-travel.de/kibbutzelifaz',
		  cssclass: 'unic-deal-1',
		  book_now: 'BUCHEN SIE JETZT',
		},
  
  
		{
		  title: 'Ventus Reisen',
		  desc:'Individuelle Reise nach Tel Aviv und Jerusalem mit Bus-Ausflügen zu den wichtigsten Sehenswürdigkeiten',
		  price: '858 € ',
		  logo: 'Deals/Ventus Reisen.jpg',
		  link:'https://www.ventus-reisen.de/408-israel-tel-aviv-und-jerusalem/',
		  cssclass: 'unic-deal-1',
		  book_now: 'BUCHEN SIE JETZT',
		},
  
		{
		  title: 'Israel Tours & Travel',
		  desc:'CITY BREAK, JERUSALEM & TEL AVIV 8 tägige Reise in Jerusalem und Tel Aviv',
		  price: '949 € ',
		  logo: 'Deals/Israel Tours & Travel.jpg',
		  link:'https://www.israel-tours-travel.de/citybreaktelavivundjerusalem',
		  cssclass: 'unic-deal-1',
		  book_now: 'BUCHEN SIE JETZT',
		},
  
		{
		  title: 'Israel Tours & Travel',
		  desc:'ISRAEL HIGHLIGHTS 8 TÄGIGE RUNDREISE  INKL. 7 Ü/HP, TRANSFERS, DEUTSCHSPRECHENDER REISELETER, ALLE EINTRITTGELDER' ,
		  price: '956 € ',
		  logo: 'Deals/Israel Tours & Travel.jpg',
		  link:'https://www.israel-tours-travel.de/israelrundreisen',
		  cssclass: 'unic-deal-1',
		  book_now: 'BUCHEN SIE JETZT',
		},
  
		{
		  title: 'DerTour',
		  desc: 'Rundreise Israel entdecken ab/bis Tel Aviv 7 Nächte/Halbpension, Rundreise mit Dt. Sprechende Reiseleitung', 
		  price: '1041 € ',
		  logo: 'Deals/DerTour.jpg',
		  link:'https://www.dertour.de/ibe/rundreise/detail?tab=angebote&locationCode=MKT_IL&locationName=Israel&serviceCode=TLV99101&productType=TOUR&serviceName=Israel+entdecken&productLineCode=VA&seasonId=21-11%2F10&earliestStart=16.01.2022&latestStart=23.01.2022&numberOfAdults=2&numberOfChildren=0&numberOfUnits=1&withDetails=true&sortByLowestPrice=true',
		  cssclass: 'unic-deal-1',
		  book_now: 'BUCHEN SIE JETZT',
		},
		{
		  title: 'Diesenhaus',
		  desc:'10 Tage Israel-Rundreise mit Mietwagen. Großes Programm, ausgewählte Hotels',
		  price: '1095 € ',
		  logo: 'Deals/Diesenhaus.jpg',
		  link:'https://www.diesenhaus.de/reiseprogramm/reise/10-tage-israel-rundreise-mit-mietwagen/',
		  cssclass: 'unic-deal-2',
		  book_now: 'BUCHEN SIE JETZT',
		},
		{
		  title: 'Diesenhaus',
		  desc:  '8 Tage Klassische Israel-Rundreise. Ideal, um das Land kennenzulernen: Jerusalem, Galiläa, Totes Meer',
		  price: '1105 € ',
		  logo: 'Deals/Diesenhaus.jpg',
		  link: 'https://www.diesenhaus.de/reiseprogramm/reise/israel-rundreise/',
		  cssclass: 'unic-deal-3',
		  book_now: 'BUCHEN SIE JETZT',
		},
		
		{
		  title: 'Ventus Reisen',
		  desc:'Individuelle 10-tägige Privatreise als Selbstfahrer-Reise im Mietwagen' ,
		  price: ' 1281 € ',
		  logo: 'Deals/Ventus Reisen.jpg',
		  link:'https://www.ventus-reisen.de/399-israel-an-den-urspruengen-von-weltreligionen/',
		  cssclass: 'unic-deal-1',
		  book_now: 'BUCHEN SIE JETZT',
		},

		{
		  title: 'Berge & Meer',
		  desc:'8-tägige Rundreise durch das Heilige Land mit Bad im Toten Meer, See Genezareth & Galiläa, Nazareth, Bethlehem & Jerusalem ' ,
		  price: ' 1299 € ',
		  logo: 'Deals/Berge & Meer.jpg',
		  link:'https://www.berge-meer.de/angebote/israel-rundreise-von-netanya-bis-tel-aviv-inkl-bad-im-toten-meer',
		  cssclass: 'unic-deal-1',
		  book_now: 'BUCHEN SIE JETZT',
		},

		{
		  title: 'Botros Tours',
		  desc: 'Rundreise „Geschichte, Kultur und Begegnung“ 8-tägige Rundreise inkl. Flüge Wien – Tel Aviv – Wien, Halbpension',
		  price: '1490 € ',
		  logo: 'Deals/Botros Tours.jpg',
		  link: 'https://www.botrostours.at/product.php?id=5036',
		  cssclass: 'unic-deal-3',
		  book_now: 'BUCHEN SIE JETZT',
		},
		{
		  title: 'Botros Tours',
		  desc: 'Rundreise „Ein Land, Zwei Völker 8-tägige Rundreise inkl. Flüge Wien – Tel Aviv – Wien, Halbpension',
		  price: '1540 € ',
		  logo: 'Deals/Botros Tours.jpg',
		  link: 'https://www.botrostours.at/product.php?id=5038',
		  cssclass: 'unic-deal-3',
		  book_now: 'BUCHEN SIE JETZT',
		},

		{
		  title: 'Biblische Reisen',
		  desc: 'JERUSALEM - Stadt der drei Religionen 8-tägige Studienreise mit Begegnungen Linienflug, Halbpension, Rundfahrten und Ausflüge, Alle Eintrittsgelder',
		  price: '1640 € ',
		  logo: 'Deals/Biblische Reisen.jpg',
		  link: 'https://biblische-reisen.de/katalogreisen/nahost/heiliges_land/hlk67_jerusalem-stadt_der_drei_religionen',
		  cssclass: 'unic-deal-4',
		  book_now: 'BUCHEN SIE JETZT',
		},

		{
		  title: 'Laufreisen',
		  desc: "Israel: Jerusalem Marathon, Halbmarathon und 10 km Run'n'Hike Israel vom 23.03.2022 bis 30.03.2022",
		  price: '1699 € ',
		  logo: 'Deals/Laufreisen.jpg',
		  link: 'https://www.laufreisen.de/reisen/jerusalem',
		  cssclass: 'unic-deal-3',
		  book_now: 'BUCHEN SIE JETZT',
		},
		{
		  title: 'Diesenhaus',
		  desc: '9 Tage Höhepunkte Israels inkl. Flug. Alle wichtigen Sehenswürdigkeiten und Orte				',
		  price: '1705 € ',
		  logo: 'Deals/Diesenhaus.jpg',
		  link:'https://www.diesenhaus.de/reiseprogramm/reise/9-tage-rundreise-israel-sonntags-inkl-flug/',
		  cssclass: 'unic-deal-1',
		  book_now: 'BUCHEN SIE JETZT',
		},
  
		{
		  title: 'Biblische Reisen',
		  desc: 'Im Land der Bibel 8-tägige Studienreise Linienflug,  Halbpension, Rundfahrten und Ausflüge, Alle Eintrittsgelder',
		  price: '1750 € ',
		  logo: 'Deals/Biblische Reisen.jpg',
		  link: 'https://biblische-reisen.de/katalogreisen/nahost/israel/hlk06_im_land_der_bibel',
		  cssclass: 'unic-deal-4',
		  book_now: 'BUCHEN SIE JETZT',
		},
  
		{
		  title: 'Israelreise.de',
		  desc: 'Israel - Botschafterreise der Sächsischen Israelfreunde e.V. inkl. HP, Trinkgelder, Flüge',
		  price: '1820 € ',
		  logo: 'Deals/jahre.jpg',
		  link: 'https://www.israelreise.de/rundreisen/r/a/israel-botschafterreise-der-saechsischen-israelfreunde-ev/3/',
		  cssclass: 'unic-deal-4',
		  book_now: 'BUCHEN SIE JETZT',
		},

  
		{
		  title: 'Biblische Reisen',
		  desc: 'Auf den Spuren Jesu 9-tägige Studienreise Linienflug, Halbpension, Rundfahrten und Ausflüge, Alle Eintrittsgelder',
		  price: '1990 € ',
		  logo: 'Deals/Biblische Reisen.jpg',
		  link: 'https://biblische-reisen.de/katalogreisen/nahost/israel/hlk09_auf_den_spuren_jesu',
		  cssclass: 'unic-deal-4',
		  book_now: 'BUCHEN SIE JETZT',
		},

		{
		  title: 'Studiosus',
		  desc: 'Heiliges Land - eine kompakte  Studienreise ins Heilige Land - 8 Tage',
		  price: '1995 € ',
		  logo: 'Deals/Studiosus.jpg',
		  link: 'https://www.studiosus.com/Israel/Studienreise/Rundreise/3601--Israel-Heiliges-Land--Fluganreise',
		  cssclass: 'unic-deal-4',
		  book_now: 'BUCHEN SIE JETZT',
		},

		{
		  title: 'Emmausreisen',
		  desc: '19. bis 27. März 2022: Heiliges Land – Entdeckungen im Land der Bibel - 9 Tage',
		  price: '1995 € ',
		  logo: 'Deals/Emmausreisen.jpg',
		  link: 'https://www.emmaus-reisen.de/tour/19-bis-27-maerz-2022-heiliges-land-entdeckungen-im-land-der-bibel-2hlp2002/',
		  cssclass: 'unic-deal-4',
		  book_now: 'BUCHEN SIE JETZT',
		},

		{
		  title: 'Emmausreisen',
		  desc: '02. bis 10. April 2022: HEILIGES LAND – Entdeckungen im Land der Bibel - 9 Tage',
		  price: '1995 € ',
		  logo: 'Deals/Emmausreisen.jpg',
		  link: 'https://www.emmaus-reisen.de/tour/02-bis-10-april-2022-heiliges-land-entdeckungen-im-land-der-bibel-2hlp2006/',
		  cssclass: 'unic-deal-4',
		  book_now: 'BUCHEN SIE JETZT',
		},

		// {
		//     title: "ABS Travel",
		//     desc: "Insight Israel | 18-30 9 tägige Rundreise für junge Erwachsene im Alter von 18 - 30 Jahre",
		//     price: " CHF 2’230 ",
		//     logo: "Deals/ABSTravel.jpg",
		//     link: "https://www.abstravel.ch/jugendreise",
		//     cssclass: "unic-deal-1",
		//     book_now: "BUCHEN SIE JETZT"
		// },
		{
		  title: 'Hauser Exkursionen',
		  desc: '9-tägige Wanderreise von der Wüste Negev zum Toten Meer und nach Galiläa mit kulturellen Höhepunkten in Masada und Jerusalem',
		  price: '2095 € ',
		  logo: 'Deals/Hauser Exkursionen.jpg',
		  link: 'https://www.hauser-exkursionen.de/reise/israel-krater-wueste-totes-meer',
		  cssclass: 'unic-deal-4',
		  book_now: 'BUCHEN SIE JETZT',
		},
		{
		  title: 'Schechinger Tours',
		  desc: 'Israel – Frühlingsreise vom 17.03.-27.03.2022',
		  price: '2099 € ',
		  logo: 'Deals/Schechinger Tours.jpg',
		  link: 'https://www.schechingertours.de/israelreise/israel-fruehlingsreise-mit-lutz-scheufler-2/',
		  cssclass: 'unic-deal-4',
		  book_now: 'BUCHEN SIE JETZT',
		},
		{
		  title: 'Schechinger Tours',
		  desc: 'Israelreise wenn die Wüste blüht vom 03.03. – 13.03.2022',
		  price: '2099 € ',
		  logo: 'Deals/Schechinger Tours.jpg',
		  link:'https://www.schechingertours.de/israelreise/israelreise-wenn-die-wueste-blueht-mit-wolfgang-und-sieglinde-wangler-pfalzgrafenweiler-und-walter-und-marianne-schechinger-wildberg-sulz-am-eck/',
		  cssclass: 'unic-deal-4',
		  book_now: 'BUCHEN SIE JETZT',
		},

		{
		  title: 'Studiosus',
		  desc: 'smart & small - Vom Sandstrand bis zur Klagemauer - 10 Tage',
		  price: '2165 € ',
		  logo: 'Deals/Studiosus.jpg',
		  link:'https://www.studiosus.com/Israel,Pal%C3%A4stinensische-Gebiete smart-and-small/3644E--Israel-vom-Sandstrand-bis-zur-Klagemauer--Eigenanreise',
		  cssclass: 'unic-deal-4',
		  book_now: 'BUCHEN SIE JETZT',
		},

  
		{
		  title: 'Biblische Reisen',
		  desc: 'Ostern im Heiligen Land 8-tägige biblische Studienreise zu Ostern Linienflug,  Halbpension, Rundfahrten und Ausflüge, Alle Eintrittsgelder',
		  price: '2325 € ',
		  logo: 'Deals/Biblische Reisen.jpg',
		  link:'https://biblische-reisen.de/katalogreisen/nahost/israel/hlk40_ostern_im_heiligen_land',
		  cssclass: 'unic-deal-4',
		  book_now: 'BUCHEN SIE JETZT',
		},
		
		{
		  title: 'Emmausreisen',
		  desc: '09. bis 19. April 2022: Heiliges Land zum Osterfest - 11 Tage',
		  price: '2345 € ',
		  logo: 'Deals/Emmausreisen.jpg',
		  link: 'https://www.emmaus-reisen.de/tour/09-bis-19-april-2022-heiliges-land-zum-osterfest-2hlp2008/',
		  cssclass: 'unic-deal-4',
		  book_now: 'BUCHEN SIE JETZT',
		},
  
		{
		  title: 'Biblische Reisen',
		  desc: 'Das Land der Bibel neu entdeckt 8-tägige Studienreise Linienflug,  Halbpension, Rundfahrten und Ausflüge, Alle Eintrittsgelder',
		  price: '2390 € ',
		  logo: 'Deals/Biblische Reisen.jpg',
		  link: 'https://biblische-reisen.de/katalogreisen/nahost/israel/hlk22_das_land_der_bibel_neu_entdeckt',
		  cssclass: 'unic-deal-4',
		  book_now: 'BUCHEN SIE JETZT',
		},

		{
		  title: 'Studiosus',
		  desc: 'Studienreise - Heiliges Land in kleiner Gruppe - 8 Tage',
		  price: '2395 € ',
		  logo: 'Deals/Studiosus.jpg',
		  link:'https://www.studiosus.com/Israel/Studienreise/Rundreise/3611--Israel-Heiliges-Land-in-kleiner-Gruppe--Fluganreise',
		  cssclass: 'unic-deal-4',
		  book_now: 'BUCHEN SIE JETZT',
		},

		{
		  title: 'Emmausreisen',
		  desc: '21. bis 31. März 2022: Heiliges Land – Entdeckungen im Land der Bibel - 11 Tage',
		  price: '2485 € ',
		  logo: 'Deals/Emmausreisen.jpg',
		  link: 'https://www.emmaus-reisen.de/tour/heiliges-land-entdeckungen-im-land-der-bibel-2hlp2007/',
		  cssclass: 'unic-deal-4',
		  book_now: 'BUCHEN SIE JETZT',
		},

		{
		  title: 'Emmausreisen',
		  desc: '04. bis 14. April 2022: Heiliges Land – Orte besuchen, die aus der Bibel vertraut sind - 11 Tage',
		  price: '2495 € ',
		  logo: 'Deals/Emmausreisen.jpg',
		  link: 'https://www.emmaus-reisen.de/tour/04-bis-14-april-2022-heiliges-land-orte-besuchen-die-aus-der-bibel-vertraut-sind-2hlp2001/',
		  cssclass: 'unic-deal-4',
		  book_now: 'BUCHEN SIE JETZT',
		},
  
  
		{
		  title: 'Hauser Exkursionen',
		  desc: '10-tägige Wanderreise auf dem Israel National Trail durch die Wüste Negev zum Roten Meer mit Besuch von Jerusalem und Tel Aviv',
		  price: '2498 € ',
		  logo: 'Deals/Hauser Exkursionen.jpg',
		  link: 'https://www.hauser-exkursionen.de/reise/israel-aus-der-wueste-in-die-heilige-stadt?variant=2022',
		  cssclass: 'unic-deal-4',
		  book_now: 'BUCHEN SIE JETZT',
		},
		{
		  title: 'Eberhardt',
		  desc: 'Silvester in Israel, 7 Tage',
		  price: '2498 € ',
		  logo: 'Deals/Eberhardt.jpg',
		  link: 'https://www.eberhardt-travel.de/reise/fernreisen/israel/telaviv-jerusalem/il-yytlv',
		  cssclass: 'unic-deal-7',
		  book_now: 'BUCHEN SIE JETZT',
		},
		{
		  title: 'Hauser Exkursionen',
		  desc: '9-tägige Wanderreise durch die Berge Galiläas und die Judäische Wüste bis nach Jerusalem',
		  price: '2595 € ',
		  logo: 'Deals/Hauser Exkursionen.jpg',
		  link: 'https://www.hauser-exkursionen.de/reise/israel-der-jerusalem-weg',
		  cssclass: 'unic-deal-4',
		  book_now: 'BUCHEN SIE JETZT',
		},
		{
		  title: 'Eberhardt',
		  desc: 'Wanderreise Israel, 13 Tage, ca. 60 Wanderkilometer',
		  price: '2748 € ',
		  logo: 'Deals/Eberhardt.jpg',
		  link: 'https://www.eberhardt-travel.de/reise/wanderreisen/israel-totes-meer/see-genezareth-totes-meer/il-aktiv',
		  cssclass: 'unic-deal-8',
		  book_now: 'BUCHEN SIE JETZT',
		},
  
		{
		  title: 'Weltweitwandern',
		  desc: '10 tägige Wanderreise - Von Galiläa bis in die Negev Wüste',
		  price: '2790 € ',
		  logo: 'Deals/Weltweitwandern.jpg',
		  link: 'https://www.weltweitwandern.at/asien/israel/israel-wege-nach-jerusalem/',
		  cssclass: 'unic-deal-9',
		  book_now: 'BUCHEN SIE JETZT',
		},
  
		{
		  title: 'Biblische Reisen',
		  desc:'Die Welt hinter den Bibeltexten 10-tägige Archäologische Studienreise Linienflug, Halbpension, Rundfahrten und Ausflüge, Alle Eintrittsgelder',
		  price: '2960 € ',
		  logo: 'Deals/Biblische Reisen.jpg',
		  link:'https://biblische-reisen.de/katalogreisen/nahost/heiliges_land/hlk60_die_welt_hinter_den_bibeltexten',
		  cssclass: 'unic-deal-4',
		  book_now: 'BUCHEN SIE JETZT',
		},
  
		{
		  title: 'Eberhardt',
		  desc: 'ausführliche Rundreise durch Israel mit Studienreisecharakter, 11 Tage',
		  price: '2998 € ',
		  logo: 'Deals/Eberhardt.jpg',
		  link:'https://www.eberhardt-travel.de/reise/fernreisen/israel-totes-meer/jerusalem-bethlehem/il-isr11',
		  cssclass: 'unic-deal-10',
		  book_now: 'BUCHEN SIE JETZT',
		},

		{
		  title: 'Studiosus',
		  desc: 'Klassik Studienreise - alte Kulturen junges Land - 10 Tage',
		  price: '3095 € ',
		  logo: 'Deals/Studiosus.jpg',
		  link:'https://www.studiosus.com/Israel/3621--Israel-alte-Kulturen-junges-Land--Fluganreise',
		  cssclass: 'unic-deal-10',
		  book_now: 'BUCHEN SIE JETZT',
		},
  
		{
		  title: 'Bike Tour',
		  desc:'In 14 Tagen mit dem Fahrrad quer durch Israel, vom fruchtbaren grünen Norden, dem See Genezareth und dem Toten Meer entlang durch die Wüste  bis ans Rote Meer.',
		  price: '3310 € ',
		  logo: 'Deals/Bike Tour_.jpg',
		  link: 'https://www.bike-tour.ch/',
		  cssclass: 'unic-deal-10',
		  book_now: 'BUCHEN SIE JETZT',
		},
					  {
		  title: 'Studiosus',
		  desc: 'Studienreise - Große Israelreise - 15 Tage',
		  price: '3495 € ',
		  logo: 'Deals/Studiosus.jpg',
		  link:'https://www.studiosus.com/Israel/Studienreise/Rundreise/3602--Israel-die-Gro%C3%9Fe-Israelreise--Fluganreise',
		  cssclass: 'unic-deal-4',
		  book_now: 'BUCHEN SIE JETZT',
		},
  
		{
		  title: 'Eberhardt',
		  desc: 'Israel für Rollstuhlfahrer, 12 Tage',
		  price: '3998 € ',
		  logo: 'Deals/Eberhardt.jpg',
		  link: 'https://www.eberhardt-travel.de/reise/reisen-mit-rollstuhl/israel/jerusalem/il-isrbh',
		  cssclass: 'unic-deal-11',
		  book_now: 'BUCHEN SIE JETZT',
		},

   ]
  }

  render() {
    const dealsHtml = this.deals.map((o) => {
      return (
        <DealItem
          key={o.title}
          brand={o.title}
          price={o.price}
          brandImg={o.logo}
          desc={o.desc}
          bookNowLink={o.link}
          descFontSize={o.fontSize}
        />
      );
    });
    return (
      <div className="deals-wrapper">
        <SimpleSlider settings={this.dealsSliderSettings}> {dealsHtml} </SimpleSlider>{' '}
      </div>
    );
  }
}

export default Deals;



// WEBPACK FOOTER //
// ./src/Components/Deals/Deals.js